import React, { useEffect } from "react";
import {
  Form,
  useActionData,
  useNavigate,
  useRouteLoaderData,
} from "react-router-dom";
import { Button, Stack, styled, TextField } from "@mui/material";
import { userUpdatePassword } from "../../../../../api/user";
import useInfoSnackbar from "../../../../../hooks/useInfoSnackbar";

const StyledInputContainer = styled(Stack)`
  gap: 2em;
  width: 80%;
  padding: 2em 0 4em;
`;

const StyledButtonContainer = styled(Stack)`
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 4em;
`;

const userPasswordUpdateAction = async ({ request }) => {
  const formData = await request.formData();

  const submission = {
    userEntityId: formData.get("userEntityId"),
    newPassword: formData.get("newPassword"),
    newPasswordRepeat: formData.get("newPasswordRepeat"),
  };

  return await userUpdatePassword({ ...submission });
};

const UserPasswordUpdateForm = () => {
  const { user } = useRouteLoaderData("adminUser");
  const actionData = useActionData();
  const navigate = useNavigate();
  const infoSnackbar = useInfoSnackbar();

  useEffect(() => {
    if (actionData) {
      if (actionData.code === "SUCCESS") {
        infoSnackbar.alertSuccess(actionData.message);
        navigate("../");
      } else {
        infoSnackbar.alertError(actionData.message);
      }
    }
  }, [actionData]);

  const handleCancelClicked = () => navigate("../", { replace: true });

  return (
    <Stack
      component={Form}
      method="POST"
      alignItems="center"
    >
      <StyledInputContainer>
        <input name="userEntityId" readOnly hidden value={user.userEntityId}/>
        <TextField
          label="Password"
          type="password"
          id="newPassword"
          name="newPassword"
          required={true}
          variant="outlined"
          fullWidth
        />
        <TextField
          label="Repeat Password"
          type="password"
          id="newPasswordRepeat"
          name="newPasswordRepeat"
          required={true}
          variant="outlined"
          fullWidth
        />
      </StyledInputContainer>
      <StyledButtonContainer>
        <Button
          type="submit"
          variant="contained"
        >
          Update Password
        </Button>
        <Button
          variant="contained"
          onClick={handleCancelClicked}
        >
          Cancel
        </Button>
      </StyledButtonContainer>
    </Stack>
  );
};
export { userPasswordUpdateAction };
export default UserPasswordUpdateForm;